define('app/editor/dialogs/EditAlertDialogView',['require','./SetAlertDialogView','glu/dialog','hbs!./EditAlertDialogView.hbs'],function(require) {
	'use strict';

	var SetAlertDialogView = require('./SetAlertDialogView'),
		dialog = require('glu/dialog');

	var minuteStr = 'minutes';
	var hourStr = 'hours';
	var dayStr = 'days';

	var view = SetAlertDialogView.extend({

		dialogTitle: 'Edit Email Alert',

		getClass: function() {
			return 'modal-edit-alert';
		},

		dialogButtons: [{
			text: 'Update',
			callback: 'update',
			className: 'btn-primary'
		}, {
			text: 'Cancel',
			callback: 'cancelCallback',
			className: 'btn-primary'
		}],

		template: require('hbs!./EditAlertDialogView.hbs'),

		initialize: function() {
			this.formattedValue1 = '';
			this.formattedValue2 = '';
			this.timeUnit1 = 'm';
			this.timeUnit2 = 'm';
		},

		update: function() {
			var payload,
				self = this,
				option = this.$el.find(this.ui.$alertType).val();

			if (self.isValidAlert()) {
				// since we are editing we should have a threshold object
				payload = this.model.getThreshold();
				payload.desirable = true;

				if (option === 'LOW' || option === 'HIGH') {
					payload.value1 = this.$el.find(this.ui.$value).val();
					payload.range = option;
					if (self.isTimespan()) {
						var timeUnit = self.ui.$timeUnit.val();
						payload.value1 = self.convertTimespan(payload.value1, timeUnit);
						payload.timeUnit1 = timeUnit;
					} else {
						payload.timeUnit1 = undefined;
					}
				} else {
					payload.value1 = this.$el.find(this.ui.$value1).val();
					payload.value2 = this.$el.find(this.ui.$value2).val();
					payload.range = option;
					if (self.isTimespan()) {
						var minTimeUnit = self.ui.$timeUnitMin.val();
						var maxTimeUnit = self.ui.$timeUnitMax.val();
						payload.value1 = self.convertTimespan(payload.value1, minTimeUnit);
						payload.value2 = self.convertTimespan(payload.value2, maxTimeUnit);
						payload.timeUnit1 = minTimeUnit;
						payload.timeUnit2 = maxTimeUnit;
					} else {
						payload.timeUnit1 = undefined;
						payload.timeUnit2 = undefined;
					}
				}

				payload.schedule = self.ui.$frequency.val();
				self.model.setThreshold(payload);
				self.model.setDirty();
				dialog.close();
			}
		},

		cancelCallback: function() {
			if (this.options.isChangedColumn) {

				var previousSelection = this.model.get('previousSelection');

				if (previousSelection) {
					this.model.set('selectedName', previousSelection.selectedName);
					this.model.set('selectedId', previousSelection.selectedId);
					this.model.set('selectedVal', previousSelection.selectedVal);
					this.model.set('selectedColType', previousSelection.selectedColType);
					this.model.set('selectedColTotal', previousSelection.selectedColTotal);
					this.model.set('selectedColAggregation', previousSelection.selectedColAggregation);
					this.model.set('selectedColIsPercentage', previousSelection.selectedColIsPercentage);
					this.model.setOption('selectedColumn', previousSelection.selectedColumn);
					this.model.setOption('donutFilterValues', previousSelection.donutFilterValues);
					if (!previousSelection.isDirty) {
						this.model.clean();
					}
				} else {
					this.model.unset('selectedName');
					this.model.unset('selectedId');
					this.model.unset('selectedVal');
					this.model.unset('selectedColType');
					this.model.unset('selectedColTotal');
					this.model.unset('selectedColAggregation');
					this.model.unset('selectedColIsPercentage');
					this.model.setOption('selectedColumn', '');
				}
			}
			this.model.trigger('change:alert:invalidate');
			dialog.close();
		},
		deleteCallback: function() {
			var self = this;
			self.model.deleteAlert().then(function() {
				dialog.close();
				self.model.fetch().then(function() {
					self.model.trigger('alertSet');
				});
			});
		},

		alertOptions: function() {
			var values = [];

			var range;
			if (this.model.getThreshold() !== undefined) {
				range = this.model.getThreshold().range;
			}
			values.push({
				label: 'Below',
				value: 'LOW',
				isSelected: this.isAlertTypeSelected('Below', range)
			});
			values.push({
				label: 'Above',
				value: 'HIGH',
				isSelected: this.isAlertTypeSelected('Above', range)
			});
			values.push({
				label: 'Within Range',
				value: 'IN_RANGE',
				isSelected: this.isAlertTypeSelected('Within Range', range)
			});
			values.push({
				label: 'Outside Range',
				value: 'OUT_RANGE',
				isSelected: this.isAlertTypeSelected('Outside Range', range)
			});

			if (this.model.getThreshold() !== undefined && !this.options.blankValues) {
				this.formatTimespan(this.model.getThreshold().value1, this.model.getThreshold().value2);
			}
			return values;
		},

		isAlertTypeSelected: function(type, range) {
			if ((type === 'Below' && range === 'LOW') ||
				(type === 'Above' && range === 'HIGH') ||
				(type === 'Within Range' && range === 'IN_RANGE') ||
				(type === 'Outside Range' && range === 'OUT_RANGE')) {
				return true;
			}
			return false;
		},

		alertvalue: function() {
			return this.formattedVal1;
		},

		alertvalue1: function() {
			return this.formattedVal1;
		},

		alertvalue2: function() {
			return this.formattedVal2;
		},

		isMinInterval: function(units) {
			if (this.alertvalue1() === 0 || this.alertvalue1() === '0') {
				return (this.timeUnit2 === units);
			} else {
				return (this.timeUnit1 === units);
			}
		},

		isMaxInterval: function(units) {
			if (this.alertvalue2() === 0 || this.alertvalue2() === '0') {
				return (this.timeUnit1 === units);
			} else {
				return (this.timeUnit2 === units);
			}
		},

		isMinMinute: function() {
			return this.isMinInterval(minuteStr);
		},

		isMaxMinute: function() {
			return this.isMaxInterval(minuteStr);
		},

		isMinHour: function() {
			return this.isMinInterval(hourStr);
		},

		isMaxHour: function() {
			return this.isMaxInterval(hourStr);
		},

		isMinDay: function() {
			return this.isMinInterval(dayStr);
		},

		isMaxDay: function() {
			return this.isMaxInterval(dayStr);
		},

		getTimeUnit: function(value) {
			if (value.indexOf('d') > 0) {
				return dayStr;
			} else if (value.indexOf('h') > 0) {
				return hourStr;
			} else if (value.indexOf('m') > 0) {
				return minuteStr;
			}
		},

		isDaily: function() {
			var data = this.model.getThreshold();
			if (data && data.schedule === 'DAILY') {
				return true;
			}
		},

		isWeekly: function() {
			var data = this.model.getThreshold();
			if (data && data.schedule === 'WEEKLY') {
				return true;
			}
		},

		isMonthly: function() {
			var data = this.model.getThreshold();
			if (data && data.schedule === 'MONTHLY') {
				return true;
			}
		},

		formatTimespan: function(value1, value2) {
			this.formattedVal1 = this.formatSeconds(value1);
			this.timeUnit1 = this.getTimeUnit(this.formattedVal1);
			this.formattedVal1 = this.formattedVal1.substring(0, this.formattedVal1.length - 1);

			this.formattedVal2 = this.formatSeconds(value2);
			this.timeUnit2 = this.getTimeUnit(this.formattedVal2);
			this.formattedVal2 = this.formattedVal2.substring(0, this.formattedVal2.length - 1);
		},

		formatSeconds: function(seconds) {
			var secondsInAMin = 60;
			var secondsInAnHour = 60 * secondsInAMin;
			var secondsInADay = 24 * secondsInAnHour;

			if (seconds === null || seconds === '') {
				return '';
			}

			if (seconds % secondsInADay === 0) {
				var days = Math.floor(seconds / secondsInADay);
				return days + 'd';
			} else if (seconds % secondsInAnHour === 0) {
				var hours = Math.floor(seconds / secondsInAnHour);
				return hours + 'h';
			} else if (seconds % secondsInAMin === 0) {
				var minutes = Math.floor(seconds / secondsInAMin);
				return minutes + 'm';
			} else {
				return seconds + 's';
			}
		}

	});

	return view;
});

